import React, { useEffect } from "react";
import "../PrivacyPolicy/styles.css";

/** 与 doc/个人信息收集清单（已完成）.docx 正文一致，仅作标题与分行展示 */
const MODULES = [
  {
    title: "1、注册登录时，可能收集的信息包括：",
    lines: [
      "1.1 手机号码",
      "1.2 用户自主填写的信息（头像、昵称、性别、生日、地区）",
      "1.3 第三方账号公开信息（头像、昵称以及用户授权的其他信息）",
      "收集目的： 用于账号注册、登录及身份验证",
    ],
  },
  {
    title: "2、使用时光云相册功能时，可能收集的信息包括：",
    lines: [
      "2.1 用户自主填写的宠物信息（宠物的名字、品种、生日、性别、头像、用户与宠物的关系）",
      "2.2 用户自主发布的照片、视频、音频及对应的文字、评论、点赞",
      "2.3 用户在发表记录时主动授权添加的位置信息",
      "2.4 用户访问时光云相册的时间和次数（可关闭）",
      "收集目的： 用于创建宠物时光相册、记录宠物成长、与亲友分享互动",
    ],
  },
  {
    title: "3、使用AI问答功能时，可能收集的信息包括：",
    lines: [
      "3.1 用户填写的宠物信息（宠物的名字、品种、生日、性别、头像、用户与宠物的关系）",
      "3.2 用户输入的提问内容（文字、语音）及上传的图片",
      "3.3 对话历史记录",
      "收集目的： 用于提供基于宠物信息的个性化问答服务，优化回答质量",
    ],
  },
  {
    title: "4、使用智能硬件功能时，可能收集的信息包括：",
    lines: [
      "4.1 设备绑定与连接：Wi-Fi网络信息（SSID、密码）；蓝牙权限状态",
      "4.2 远程操控与实时音视频：操控指令（移动方向、模式切换）、实时音视频流（仅转发，不永久存储）；摄像头、麦克风、存储权限状态",
      "4.3 智能跟随与异常检测：设备采集的环境信息（距离、障碍物）、宠物活动状态、设备位置信息（基于室内定位或GPS）、异常检测触发的短时视频片段",
      "4.4 多用户共享：被邀请人的账号信息（昵称、头像）",
      "4.5 设备绑定信息、操控日志（不含音视频）",
      "收集目的： 用于智能硬件的绑定、远程操控、安全监护及多用户共享",
    ],
  },
  {
    title: "5、使用基于系统权限的附加服务时，可能收集的信息包括：",
    lines: [
      "5.1 位置权限：用于发布记录时选择保存地理位置、辅助填写收货地址、扫描绑定设备时获取附近Wi-Fi信息",
      "5.2 相机权限：用于拍摄照片/视频（发布、更换头像、AI问答上传图片、客服沟通、扫码关注）",
      "5.3 相册权限：用于上传照片/视频（发布、更换头像、AI问答、保存文件、客服沟通）",
      "5.4 麦克风权限：用于录制音频（发布录音、视频拍摄录音、AI问答语音输入、语音消息、智能硬件语音对讲）",
      "5.5 蓝牙权限：用于扫描连接智能设备、获取设备信息",
      "收集目的： 用于实现各项附加功能，提升用户体验",
    ],
  },
  {
    title: "6、使用消息推送功能时，可能收集的信息包括：",
    lines: [
      "6.1 设备标识信息（Android ID、OAID、IDFA/IDFV）",
      "6.2 推送令牌（Push Token）",
      "6.3 设备型号、操作系统类型及版本、应用版本号",
      "6.4 IP地址、网络类型及必要的网络信息",
      "收集方式：通过阿里云移动推送 SDK 在初始化、注册推送服务、接收推送或设备重启后恢复通知/推送服务状态时自动读取或生成",
      "收集目的：用于推送设备识别、生成推送令牌、消息下发、到达统计、故障排查及设备重启后恢复推送服务，确保您在App关闭、后台运行或设备重启后可正常接收推送通知",
      "使用范围：仅用于消息推送、通知提醒相关服务，不用于广告画像、个性化推荐或其他无关目的；不会在无关场景下频繁自启动或关联启动其他应用。您可以在系统设置中关闭通知权限，关闭后将无法接收消息提醒，但不影响其他非推送功能的正常使用",
    ],
  },
  {
    title: "7、运营与安全保障，可能收集的信息包括：",
    lines: [
      "7.1 设备信息：设备型号、操作系统版本、设备标识符（IDFA、Android ID、OAID等）、IP地址、BSSID/SSID、WIFI列表、移动网络信息（MCC、MNC）及其他软硬件特征信息",
      "7.2 服务日志信息：操作记录、日志信息",
      "7.3 设备所在位置相关信息（GPS位置、通过IP地址、WLAN接入点、蓝牙和基站、传感器信息获取的位置信息）",
      "收集目的： 用于保障产品运营安全、分析产品稳定性、排查故障及统计服务情况",
    ],
  },
];

export default function PersonalInfoCollectionList() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="privacy-policy-page personal-info-collection-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>个人信息收集清单</h1>
      {MODULES.map((mod, i) => (
        <section key={i} className="collection-module">
          <h3 className="collection-module-title">{mod.title}</h3>
          <div className="collection-module-body">
            {mod.lines.map((line, j) => (
              <p key={j}>{line}</p>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
